import { render, staticRenderFns } from "./client-report-assignments-table.vue?vue&type=template&id=6bd60e4a"
import script from "./client-report-assignments-table.vue?vue&type=script&lang=js"
export * from "./client-report-assignments-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports